<template>
  <div class="home">
    <mu-container class="index_content">
      <!-- <mu-paper :z-depth="1" class="demo-list-wrap"> -->
      <mu-appbar color="indigo500"> 报表中心 </mu-appbar>
      <mu-list>
        <!-- <mu-sub-header>报表</mu-sub-header> -->
        <mu-list-item
          avatar
          button
          :ripple="false"
          :to="{ name: 'IncomeReport' }"
        >
          <mu-list-item-action>
            <mu-avatar color="teal500">
              <i class="mdui-icon material-icons">&#xe24b;</i>
            </mu-avatar>
          </mu-list-item-action>
          <mu-list-item-title>门店每日营收查询</mu-list-item-title>
        </mu-list-item>
        <mu-list-item
          avatar
          button
          :ripple="false"
          :to="{ name: 'CostReport' }"
        >
          <mu-list-item-action>
            <mu-avatar  color="pink500">
              <i class="mdui-icon material-icons">&#xe24b;</i>
            </mu-avatar>
          </mu-list-item-action>
          <mu-list-item-title>财务审批费用查询</mu-list-item-title>
        </mu-list-item>
        <mu-list-item
          avatar
          button
          :ripple="false"
          :to="{ name: 'IncomeCost' }"
        >
          <mu-list-item-action>
            <mu-avatar color="indigo500">
              <i class="mdui-icon material-icons">&#xe616;</i>
            </mu-avatar>
          </mu-list-item-action>
          <mu-list-item-title>收入费用一览表（按月份）</mu-list-item-title>
        </mu-list-item>
        <mu-list-item
          avatar
          button
          :ripple="false"
          :to="{ name: 'IncomeCostHospital' }"
        >
          <mu-list-item-action>
            <mu-avatar color="indigo500">
              <i class="mdui-icon material-icons">&#xe616;</i>
            </mu-avatar>
          </mu-list-item-action>
          <mu-list-item-title>收入费用一览表（按机构）</mu-list-item-title>
        </mu-list-item>
      </mu-list>

      <!-- </mu-paper> -->
    </mu-container>

    <Footer active="Index"></Footer>
  </div>
</template>

<script>
// @ is an alias to /src
import Footer from "../../components/Report/Footer.vue";

export default {
  name: "Home",
  components: {
    Footer,
  },
  data() {
    return {
      open: "send",
    };
  },
  created() {
    document.title = "报表中心";
    this.getReportPremiss();
  },
  methods: {
    getReportPremiss(){
      this.$http.get('report_permiss')
      .then((res)=>{
        if(res.data.code == 204){
          this.$router.push({name:'Login'});  
          return false;
        }
        if(res.data.code != 200){
          this.$dialog.alert({
            message: '重复提交，请稍等。',
          })
          return false;
        }
      })
    }
  },
};
</script>
<style scoped>
.payment {
  margin: 0px 10px 100px 10px;
  padding-top: 10px;
}
.icon-container {
  display: flex;
  width: 300px;
  justify-content: space-around;
  margin: 0px auto;
}
.icon-container .mu-icon {
  margin-bottom: 12px;
}
.home-container {
  padding-top: 50px;
  background-color: white;
}
.grid-cell {
  border: 1px solid #999;
  margin-right: -1px;
}
.index_content {
  margin-bottom: 80px;
}
.mu-sub-header {
  text-align: left;
}
/* .mu-list{
  margin-top:5px;
} */
.mu-item-sub-title {
  white-space: normal;
}
.administrative_list {
  margin-top: 10px;
  margin-bottom: 10px;
}
.administrative {
  height: 60px;
}
</style>



